import keybindingsInputSchema from './keybindings-input-schema.graphql'
import keybindingsSchema from './keybinding-schema.graphql';

export { keybindingsSchema, keybindingsInputSchema };
